import { render, staticRenderFns } from "./SilentRenew.vue?vue&type=template&id=56f8e470&"
import script from "./SilentRenew.vue?vue&type=script&lang=js&"
export * from "./SilentRenew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports